import CineService from './CineService';
export default CineService;
